module.exports = __webpack_public_path__ + "static/tribe-of-mentors-e1b02febfeac472ebdbae02145aee271.jpg";